import { downloadExcel } from './reportExport';

export function downloadCsv(columns, rows, filename) {
  const headers = columns.map((c) => c.label);
  const keys = columns.map((c) => c.key);
  const escape = (value) => {
    const str = value === null || value === undefined ? '' : String(value);
    if (/[",\n]/.test(str)) {
      return `"${str.replace(/"/g, '""')}"`;
    }
    return str;
  };
  const lines = [headers.map(escape).join(',')];
  rows.forEach((row) => {
    lines.push(keys.map((k) => escape(row[k])).join(','));
  });
  const blob = new Blob([lines.join('\n')], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  link.click();
  URL.revokeObjectURL(link.href);
}

export function exportStockTable(columns, rows, baseName, format = 'excel') {
  if (format === 'csv') {
    downloadCsv(columns, rows, baseName);
    return;
  }
  downloadExcel(columns, rows, baseName);
}

export function printStockTable(title, columns, rows) {
  const head = columns.map((c) => `<th>${c.label}</th>`).join('');
  const body = rows
    .map(
      (row) => `<tr>${columns
        .map((c) => `<td>${row[c.key] ?? ''}</td>`)
        .join('')}</tr>`
    )
    .join('');
  const html = `<!DOCTYPE html><html><head><title>${title}</title>
    <style>body{font-family:Arial,sans-serif;padding:24px}table{border-collapse:collapse;width:100%}
    th,td{border:1px solid #ddd;padding:8px;font-size:12px}th{background:#4ce1b6}</style></head>
    <body><h2>${title}</h2><table><thead><tr>${head}</tr></thead><tbody>${body}</tbody></table></body></html>`;
  const w = window.open('', '_blank');
  if (!w) return;
  w.document.write(html);
  w.document.close();
  w.focus();
  w.print();
}

export const STOCK_STATUS_LABELS = {
  in_stock: 'Available',
  low_stock: 'Low Stock',
  out_of_stock: 'Out Of Stock',
  cancelled: 'Cancelled',
};

export const STOCK_STATUS_COLORS = {
  in_stock: '#4ce1b6',
  low_stock: '#ffb74d',
  out_of_stock: '#ef5350',
  cancelled: '#9e9e9e',
};
